// RPR Reparations Art — Theme JS

document.addEventListener('DOMContentLoaded', function() {

  var nav = document.querySelector('.rpr-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  var hamburger = document.querySelector('.hamburger');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('open');
      hamburger.classList.toggle('open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  document.querySelectorAll('.mobile-nav-link').forEach(function(link) {
    link.addEventListener('click', function() {
      if (mobileMenu) mobileMenu.classList.remove('open');
      if (hamburger) hamburger.classList.remove('open');
      document.body.style.overflow = '';
    });
  });

  var cartOverlay = document.querySelector('.cart-overlay');
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartBtn = document.querySelector('.nav-cart-btn');
  var cartClose = document.querySelector('.cart-close');
  var cartCountEl = document.querySelector('.cart-count');

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer) cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer) cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartBtn) cartBtn.addEventListener('click', function() {
    cartDrawer && cartDrawer.classList.contains('open') ? closeCart() : openCart();
  });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function(e) { console.log('Cart fetch error', e); });
  }

  function renderCart(cart) {
    var bodyEl = document.querySelector('.cart-body');
    var footerEl = document.querySelector('.cart-footer');
    var shipBar = document.querySelector('.shipping-bar');
    if (!bodyEl) return;
    if (cartCountEl) cartCountEl.textContent = cart.item_count;
    if (cart.item_count === 0) {
      bodyEl.innerHTML = '<div class="cart-empty-msg"><div class="cart-empty-title">Bag\'s empty.</div><div class="cart-empty-sub">The drop won\'t wait. Move first.</div><a href="/collections/june-2026-drop" class="btn-primary" style="margin:0 auto">Shop Now</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      if (shipBar) shipBar.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function(item, i) {
      html += '<div class="cart-item">';
      html += '<div class="cart-item-img">';
      if (item.image) html += '<img src="' + item.image + '" alt="' + item.title + '">';
      html += '</div><div class="cart-item-details">';
      html += '<div class="cart-item-name">' + item.product_title + '</div>';
      html += '<div class="cart-item-variant">' + item.variant_title + '</div>';
      html += '<div style="display:flex;align-items:center;gap:10px">';
      html += '<button class="qty-btn" onclick="RPR.changeQty(' + (i+1) + ',' + (item.quantity-1) + ')">&#8722;</button>';
      html += '<span class="qty-count">' + item.quantity + '</span>';
      html += '<button class="qty-btn" onclick="RPR.changeQty(' + (i+1) + ',' + (item.quantity+1) + ')">+</button>';
      html += '<button class="cart-item-remove" onclick="RPR.changeQty(' + (i+1) + ',0)">&#10005;</button>';
      html += '</div></div>';
      html += '<div class="cart-item-price">\u00a3' + (item.line_price/100).toFixed(2) + '</div></div>';
    });
    bodyEl.innerHTML = html;
    if (footerEl) {
      footerEl.style.display = 'block';
      var amtEl = footerEl.querySelector('.cart-subtotal-amount');
      if (amtEl) amtEl.textContent = '\u00a3' + (cart.total_price/100).toFixed(2);
    }
    if (shipBar) {
      shipBar.style.display = 'block';
      var fill = shipBar.querySelector('.shipping-bar-fill');
      var note = shipBar.querySelector('.shipping-bar-note');
      var pct = Math.min(100,(cart.total_price/10000)*100);
      if (fill) fill.style.width = pct + '%';
      if (note) note.innerHTML = cart.total_price >= 10000 ? '<strong>Free shipping unlocked</strong>' : 'Add <strong>\u00a3' + ((10000-cart.total_price)/100).toFixed(2) + '</strong> more for free UK shipping';
    }
  }

  window.RPR = window.RPR || {};

  RPR.addToCart = function(variantId, qty) {
    fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:variantId,quantity:qty||1}) })
      .then(function(r){return r.json();})
      .then(function(){if(cartCountEl){cartCountEl.classList.add('bump');setTimeout(function(){cartCountEl.classList.remove('bump');},350);}openCart();})
      .catch(function(e){console.log('Add to cart error',e);});
  };

  RPR.changeQty = function(line, qty) {
    fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({line:line,quantity:qty}) })
      .then(function(r){return r.json();})
      .then(function(cart){renderCart(cart);})
      .catch(function(e){console.log('Cart change error',e);});
  };

  document.querySelectorAll('.accordion-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var panel = btn.nextElementSibling;
      var isOpen = btn.classList.toggle('open');
      if (panel) panel.classList.toggle('open', isOpen);
    });
  });

  var emailForm = document.querySelector('.email-form');
  if (emailForm) {
    var emailInput = emailForm.querySelector('.email-input');
    var emailSubmit = emailForm.querySelector('.email-submit');
    var emailSuccess = document.querySelector('.email-success');
    function submitEmail() {
      if (emailInput && emailInput.value && emailInput.value.indexOf('@') > -1) {
        fetch('/contact', { method:'POST', headers:{'Content-Type':'application/x-www-form-urlencoded'}, body:'form_type=customer&email='+encodeURIComponent(emailInput.value)+'&contact[tags]=newsletter' }).catch(function(){});
        emailForm.style.opacity = '0.3'; emailForm.style.pointerEvents = 'none';
        if (emailSuccess) emailSuccess.classList.add('show');
      } else { if (emailInput) { emailInput.style.outline='2px solid #000'; emailInput.focus(); setTimeout(function(){emailInput.style.outline='';},800); } }
    }
    if (emailSubmit) emailSubmit.addEventListener('click', submitEmail);
    if (emailInput) emailInput.addEventListener('keydown', function(e){if(e.key==='Enter')submitEmail();});
  }

  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var rvObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if(e.isIntersecting){e.target.classList.add('visible');rvObs.unobserve(e.target);} });
    }, { threshold:0.07, rootMargin:'0px 0px -32px 0px' });
    reveals.forEach(function(el){rvObs.observe(el);});
  }

  var atcBtn = document.querySelector('.product-atc-btn');
  if (atcBtn) {
    atcBtn.addEventListener('click', function() {
      var vid = atcBtn.dataset.variantId;
      if (vid) RPR.addToCart(vid, 1);
    });
  }

  document.querySelectorAll('.product-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var main = document.querySelector('.product-gallery-main img');
      if (main && thumb.dataset.src) {
        main.src = thumb.dataset.src;
        document.querySelectorAll('.product-thumb').forEach(function(t){t.classList.remove('active');});
        thumb.classList.add('active');
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeCart(); if(mobileMenu) mobileMenu.classList.remove('open'); if(hamburger) hamburger.classList.remove('open'); document.body.style.overflow=''; }
  });

  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){if(cartCountEl)cartCountEl.textContent=cart.item_count;}).catch(function(){});

});
